import styled from 'styled-components';

export const AbsoluteItemContainer = styled.div.attrs(() => ({
    'data-test': 'absolute-item-container',
}))``;
